import React, { useState } from "react";
import Agent101Content from "./content/Agent101Content";
import HowToUseStackformContent from "./content/HowToUseStackformContent";
import PersonasContent from "./content/PersonasContent";
import Prompting101Content from "./content/Prompting101Content";
import TermsOfServiceContent from "./content/TermsOfServiceContent";
import TutorialContent from "./content/TutorialContent";
import UpcomingFeaturesContent from "./content/UpcomingFeaturesContent";
import WhatIsStackformContent from "./content/WhatIsStackformContent";
import WorkflowsContent from "./content/WorkflowsContent";
import { useAuth } from "../hooks/useAuth";

const MODAL_STYLE = {
  position: "fixed", top: 0, left: 0,
  width: "100%", height: "100%",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex", justifyContent: "center", alignItems: "center",
  zIndex: 3000,
};

const MODAL_BOX_STYLE = {
  backgroundColor: "var(--panel-background, #fff)",
  color: "var(--text-color, #000)",
  padding: "20px", borderRadius: "8px",
  maxWidth: "600px", maxHeight: "80vh",
  overflowY: "auto", position: "relative",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  border: "1px solid var(--panel-border, #ccc)",
};

const CLOSE_BTN_STYLE = {
  position: "absolute", top: "10px", right: "10px",
  background: "none", border: "none",
  fontSize: "1.5rem", cursor: "pointer", color: "inherit",
};

function Modal({ onClose, title, children }) {
  return (
    <div style={MODAL_STYLE} onClick={onClose}>
      <div style={MODAL_BOX_STYLE} onClick={(e) => e.stopPropagation()}>
        <button style={CLOSE_BTN_STYLE} onClick={onClose}>&times;</button>
        {title && <h2 style={{ marginTop: 0 }}>{title}</h2>}
        {children}
      </div>
    </div>
  );
}

function AboutSection({ contact, setContact, handleContactSubmit, contactStatus }) {
  const { user, dismissTutorial, restoreTutorial } = useAuth();
  const [showWhatIs, setShowWhatIs]         = useState(false);
  const [showAgent, setShowAgent]           = useState(false);
  const [showPrompting, setShowPrompting]   = useState(false);
  const [showTutorial, setShowTutorial]     = useState(false);
  const [showWorkflows, setShowWorkflows]   = useState(false);
  const [showPersonas, setShowPersonas]     = useState(false);
  const [showUsing, setShowUsing]           = useState(false);
  const [showFeatures, setShowFeatures]     = useState(false);
  const [showTerms, setShowTerms]           = useState(false);

  const navigateToContact = (closeFn) => {
    closeFn(false);
    setShowWhatIs(true);
    setTimeout(() => {
      document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  const links = [
    { label: "What is Stackform?",  onClick: () => setShowWhatIs(true) },
    { label: "Agent",               onClick: () => setShowAgent(true) },
    { label: "Prompting",           onClick: () => setShowPrompting(true) },
    { label: "Tutorials",           onClick: () => setShowTutorial(true) },
    { label: "Workflows",           onClick: () => setShowWorkflows(true) },
    { label: "Personas",            onClick: () => setShowPersonas(true) },
    { label: "Using Stackform",     onClick: () => setShowUsing(true) },
    { label: "Upcoming Features",   onClick: () => setShowFeatures(true) },
    { label: "Terms of Service",    onClick: () => setShowTerms(true) },
  ];

  return (
    <div className="about-section">
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {links.map(({ label, onClick }) => (
          <li key={label}>
            <button onClick={onClick} className="link-button">{label}</button>
          </li>
        ))}
      </ul>

      {showWhatIs && (
        <Modal title="What is Stackform?" onClose={() => setShowWhatIs(false)}>
          <WhatIsStackformContent
            contact={contact} setContact={setContact}
            handleContactSubmit={handleContactSubmit} contactStatus={contactStatus}
          />
        </Modal>
      )}
      {showAgent && (
        <Modal onClose={() => setShowAgent(false)}>
          <Agent101Content />
        </Modal>
      )}
      {showPrompting && (
        <Modal onClose={() => setShowPrompting(false)}>
          <Prompting101Content />
        </Modal>
      )}
      {showTutorial && (
        <Modal onClose={() => setShowTutorial(false)}>
          <TutorialContent
            onDismiss={dismissTutorial}
            onRestore={restoreTutorial}
            showAtStartup={user?.show_tutorial ?? false}
          />
        </Modal>
      )}
      {showWorkflows && (
        <Modal onClose={() => setShowWorkflows(false)}>
          <WorkflowsContent />
        </Modal>
      )}
      {showPersonas && (
        <Modal onClose={() => setShowPersonas(false)}>
          <PersonasContent />
        </Modal>
      )}
      {showUsing && (
        <Modal onClose={() => setShowUsing(false)}>
          <HowToUseStackformContent />
        </Modal>
      )}
      {showFeatures && (
        <Modal title="Upcoming Features" onClose={() => setShowFeatures(false)}>
          <UpcomingFeaturesContent
            onNavigateToContact={() => navigateToContact(setShowFeatures)}
          />
        </Modal>
      )}
      {showTerms && (
        <Modal title="Terms of Service" onClose={() => setShowTerms(false)}>
          <TermsOfServiceContent
            onNavigateToContact={() => navigateToContact(setShowTerms)}
          />
        </Modal>
      )}
    </div>
  );
}

export default AboutSection;
